import React, { Dispatch, SetStateAction } from "react"
import { Checkbox } from "@material-ui/core"
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import theme from "../../../theme"

type Props = {
    options: any;
    selected: string[];
    select: Dispatch<SetStateAction<string[]>>;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
        }
    }),
);

const CheckboxGroup = (props: Props) => {
    const classes = useStyles();

    const isChecked = (value: string) => {
        return props.selected.indexOf(value) > -1
    }

    const select = (value: string) => {
        const index = props.selected.indexOf(value)
        if (index > -1) {
            const list = props.selected.filter(el => el !== value)
            props.select(list)
        } else {
            props.select([...props.selected, value])
        }
    }
    return (
        <div style={{ width: "100%" }}>
            {props.options.map((el, index: number) => (
                <div className={classes.container}>
                    <Checkbox
                        checked={isChecked(el.value)}
                        key={index}
                        onClick={() => select(el.value)}
                    />
                    <img src={el.img} alt="3pl image" width="30px" height="30px" />
                    <h4 style={{ marginRight: "5px" }}>{el.label}</h4>
                </div>
            ))}
        </div>
    )
}

export default CheckboxGroup;